import React from "react";
import { Outlet } from "react-router-dom";
import "./NewsLayout.css";

const NewsLayout = () => {
  return (
    <div className="NewsLayout">
      <Outlet />
    </div>
  );
};

export default NewsLayout;
